import AgentLeftSection from 'components/AgentLeftSection/AgentLeftSection'
import AgentRightSection from 'components/AgentRightSection/AgentRightSection'
import Layout from 'components/Layout/Layout'
import React, { Component } from 'react'
import { Col } from "react-bootstrap";
import "./Dashboard.scss";
import { getUser, getUsername, getToken, getGroup } from "utils/Common";
import { UserGroup } from 'constants/UserConstants';
import { uepClient, getBaseURL, cvFleetEdgeWebsocketApiBaseURL } from "uepClient";
import StompClient from "components/Dashboard/StompClient";
import { connect } from "react-redux";
import { agentBackGroundMessageCount } from "actions/agentSocketActions";
import { ReceiveMessageService, SendMessageService } from 'services/MessageService';
import { AgentTabView } from 'constants/ChatViewConstants';
import WithAlert from 'hoc/WithAlert';

const RECONNECT_BASE_DELAY_MS = 1000;
const RECONNECT_MAX_DELAY_MS = 30000;
// Brief drops reconnect silently; only tell the agent once it is taking a while.
const RECONNECT_ALERT_AFTER_ATTEMPTS = 3;

export class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.group = getGroup();
    this.currentAgentId = getUsername();
    this.reconnectAttempts = 0;
    this.reconnectTimer = null;
    this.unmounted = false;
  }

  componentDidMount() {
    this.initializeChatSocketAndSubscribe();
    SendMessageService.listen().subscribe(this.onSendNewMessage);
  }

  componentWillUnmount() {
    this.unmounted = true;
    clearTimeout(this.reconnectTimer);
    this.stompClient.disconnect();
  }

  initializeChatSocketAndSubscribe = () => {
    let CHAT_SOCKET_URL = this.getWebsocketApiUrl();
    const client = new StompClient(CHAT_SOCKET_URL);
    this.stompClient = client;
    client.connect(
      { Authentication: getToken() },
      this.onSocketConnected,
      () => this.onSocketError(client)
    );
  };

  getWebsocketApiUrl = () => {
    const group = getGroup();
    let baseUrl;
    if (UserGroup.FLEET_EDGE === group) {
      baseUrl = cvFleetEdgeWebsocketApiBaseURL;
    }
    else {
      baseUrl = getBaseURL();
    }
    return `${baseUrl}/chatWS`;
  };

  onSocketConnected = () => {
    if (this.reconnectAttempts > 0) {
      // Messages pushed while disconnected are not replayed by the server.
      this.props.showAlert({
        variant: "warning",
        content: (
          <span>
            Chat connection restored. If a customer message seems missing, please refresh the page.
          </span>
        ),
      });
    }
    this.reconnectAttempts = 0;
    const { currentAgentId } = this;
    this.stompClient.subscribe(
      `/user/${currentAgentId}/queue/messages`,
      this.onMessageReceived
    );
  };
  onMessageReceived = (msg) => {
    console.log("onMessageReceived msg", msg)
    if (this.props.agentTab.section == AgentTabView.AGENT_CHAT) {
      ReceiveMessageService.receive(msg);
    } else {
      const count = this.props.agentBgMsgCount.count + 1
      this.props.agentBackGroundMessageCount(count)
    }
  }
  // stompjs reports both a failed connect and a dropped connection here: reconnect with back-off
  // instead of leaving the agent without a socket until they refresh.
  onSocketError = (client = this.stompClient) => {
    // Closing the socket below makes stompjs report this client's error again; handle it once.
    if (this.unmounted || client.reconnectScheduled) {
      return;
    }
    client.reconnectScheduled = true;
    client.close();
    const delay = Math.min(
      RECONNECT_BASE_DELAY_MS * 2 ** this.reconnectAttempts,
      RECONNECT_MAX_DELAY_MS
    );
    this.reconnectAttempts += 1;
    if (this.reconnectAttempts === RECONNECT_ALERT_AFTER_ATTEMPTS) {
      this.props.showAlert({
        variant: "danger",
        content: (
          <span>
            <b>Chat connection lost. </b> Reconnecting…
          </span>
        ),
      });
    }
    clearTimeout(this.reconnectTimer);
    this.reconnectTimer = setTimeout(this.initializeChatSocketAndSubscribe, delay);
  };

  onSendNewMessage = (message) => {
    /*
      Message structure to be of:
      {
        conversationId:"c123",
        "phoneNumber:9034234234"
        "agentId":"ap_532865",
        "message":"Hello, from agent"
      }
     */
    // Adding a new message as agent
    this.stompClient.send("/chat-service/chat", message);
  };

  render() {
    return (

      <Layout className="dashboard-page">
        <div className="dashboard main-section">
          {this.group == UserGroup.FLEET_EDGE ?
            <Col className="AgentLeftSection">
              <AgentLeftSection />
            </Col>
            :
            null}
          <Col className="AgentRightSection">
            <AgentRightSection />
          </Col>
        </div>
      </Layout>

    )
  }
}

const mapStateToProps = (state) => ({
  agentTab: state.agentTab,
  agentBgMsgCount: state.agentBgMsgCount
});
const mapDispatchToProps = {
  agentBackGroundMessageCount,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithAlert(Dashboard));
